import { Organization } from '../organization';

export class AllianceLockboxAssociation
{
    managementCompanyId: string;
    associationId: string;
    name: string;
    activeMemberCount: number;
    organization: Organization;

    constructor(ref) {
        this.managementCompanyId = ref.managementCompanyId;
        this.name = ref.name;
        this.associationId = ref.associationId;
        this.activeMemberCount = ref.activeMemberCount;
        this.organization = ref.organization ? new Organization(ref.organization) : null;
    }
}
